import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcArrowdropFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.45 9c.46 0 .716.539.429.903l-5.45 6.888a.546.546 0 0 1-.858 0l-5.45-6.888C5.834 9.539 6.09 9 6.551 9z"
  }));
}
var IcArrowdropFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcArrowdropFill));

export { IcArrowdropFill as I };
